export default __webpack_public_path__ + "static/media/carlIntro.459867b5.png";